import React from 'react';
import {Formik, Form} from 'formik';
import update from 'immutability-helper';
import * as yup from 'yup';
import {t} from 'ttag';

import Wrapper from '../../../../../wrapper/wrapper.jsx';
import Line from '../../../../../line/line.jsx';
import Button, {SaveButton} from '../../../../../button/button';
import Preloader from '../../../../../preloader/preloader.jsx';
import EmptyBox from '../../../../../empty-box/empty-box.jsx';
import {useAppContext} from '../../../../../../app-context.js';
import {useConnectionListContext} from '../../../../connection-list-context.js';
import {useConnectionContext} from '../../../connection-context.js';
import {useSettingsContext} from '../../settings-context.js';
import {useRequest} from '../../../../../../common/hooks';
import {updateConnectionConfigReq} from '../../../../../../common/api/amo.js';
import {trimValues} from '../../../../../../common/actions.js';
import {updateConnectionReq} from '../../../../../../common/api/api.js';
import * as Title from 'components/title/title.jsx';

import Closed from './closed/closed.jsx';
import FirstMessage from './first-message/first-message.jsx';
import Groups from './group/group.jsx';
import IfContact from './if-contact/if-contact.jsx';
import ManagerSign from './manager-sign/manager-sign.jsx';
import PipelineSettings from './pipeline-settings/pipeline-settings.jsx';
import IsLeadscanner from './is-leadscanner/is-leadscanner.jsx';

const Amocrm = () => {
  const {setNotificationList, user, lang} = useAppContext();
  const {client, setSettingsId, setConnectionList} = useConnectionListContext();
  const {connection} = useConnectionContext();
  const {connectionConfig, updateConnectionConfig} = useSettingsContext();

  const {crmRequest, request} = useRequest();

  const handleSubmit = async values => {
    const is_leadscanner = values.is_leadscanner;

    const trimmedValues = trimValues(values);
    delete trimmedValues.is_leadscanner;

    const [res, instance] = await Promise.all([
      crmRequest({
        crm: client.crm,
        ...updateConnectionConfigReq({
          domain: client.domain,
          phone: connection.phone,
          data: trimmedValues
        })
      }),
      lang == 'ru'
        ? request(
            updateConnectionReq({
              chat_key: connection.chat_key,
              data: {is_leadscanner}
            })
          )
        : undefined
    ]);

    if (Object.keys(res).length > 3) {
      setNotificationList(prevValue =>
        update(prevValue, {
          $push: [
            {
              title: connection.label || `${t`Connection`} ${connection.id}`,
              text: t`The settings have been successfully saved.`
            }
          ]
        })
      );

      updateConnectionConfig(res);
      setSettingsId(-1);
    }

    if (instance) {
      setConnectionList(prevValue => {
        const index = prevValue.findIndex(item => item.id == connection.id);
        if (index == undefined || undefined < 0) return prevValue;

        return update(prevValue, {
          [index]: {is_leadscanner: {$set: instance.is_leadscanner}}
        });
      });
    }

    return true;
  };

  const initialValues = connectionConfig
    ? {
        closed: connectionConfig.closed || false,
        first_message: connectionConfig.first_message || false,
        group: connectionConfig.group || false,
        if_contact: connectionConfig.if_contact,
        manager_sign: connectionConfig.manager_sign || false,
        pipeline_settings: connectionConfig.pipeline_settings || [],
        strategy: connectionConfig.strategy || '',
        is_leadscanner: connection.is_leadscanner
      }
    : {};

  const validationSchema = yup.object().shape({
    closed: yup.bool(),
    group: yup.bool(),
    if_contact: yup.bool(),
    pipeline_settings: yup.array(),
    strategy: yup.string()
  });

  return (
    <>
      {connectionConfig ? (
        Object.keys(connectionConfig).length ? (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={handleSubmit}
          >
            <Form>
              <Wrapper gap={16} isColumn>
                <PipelineSettings />

                <Wrapper isColumn>
                  <Title.H3>{t`Create leads`}</Title.H3>
                  <Closed />
                  <FirstMessage />
                  {user.crm == 'TELEGRAM' && lang == 'ru' && <IsLeadscanner />}
                </Wrapper>

                <Wrapper isColumn>
                  <Title.H3>{t`Other`}</Title.H3>
                  <Groups />
                  <IfContact />
                  <ManagerSign />
                </Wrapper>
              </Wrapper>

              <Line />

              <Wrapper>
                <SaveButton>{t`Save`}</SaveButton>

                <Button color="white" onClick={() => setSettingsId(-1)}>
                  {t`Cancel`}
                </Button>
              </Wrapper>
            </Form>
          </Formik>
        ) : (
          <EmptyBox />
        )
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default Amocrm;
